




























































  import { defineComponent, ref, computed } from 'vue'
  import pages from '~/pages/breadcrumbs'
  import useCurrentInstance from '~/utils/useCurrentInstance'

  export default defineComponent({
    name: 'BrandsPage',
    meta: {
      breadcrumb: {
        name: pages.BRANDS,
        link: 'brands',
      },
    },
    setup() {
      const vm = useCurrentInstance()
      const searchQuery = ref('')

      const brandsTree = computed(() => vm.$store.getters['brands/getBrandsTree'])
      const filteredBrandsTree = computed(() => {
        if (!searchQuery.value) {
          return brandsTree.value
        }

        const query = searchQuery.value.toLowerCase()

        return brandsTree.value
          .map((item) => {
            const brandMatches = item.brand.name.toLowerCase().includes(query)
            const filteredSeries = item.series.filter(s =>
              s.name.toLowerCase().includes(query),
            )

            if (brandMatches || filteredSeries.length > 0) {
              return {
                ...item,
                series: brandMatches ? item.series : filteredSeries,
              }
            }

            return null
          })
          .filter(item => item !== null)
      })

      const onSearch = (value: string) => {
        searchQuery.value = value
      }

      return {
        brandsTree,
        filteredBrandsTree,
        onSearch,
      }
    },
    async fetch({ store, app }) {
      const brandsTree = store.getters['brands/getBrandsTree']
      try {
        if (!brandsTree.length) {
          await store.dispatch('brands/fetchBrandsTree')
        }
      } catch (error) {
        app.$logger.error(error)
      }
    },
  })
